import * as React from "react"
import { App } from "./app"
import { TreeViewGW } from "./TreeViewGW"
import { PADebug } from "./PADebug"

///////  Reading json files /////////

function GetFromUrl(yourUrl:string) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", yourUrl, false);
    Httpreq.send(null);
    return Httpreq.responseText;
}

///////////////   TreeItemGW  ////////////////

export interface TreeItemVm {
    itemText: string
    level: number // 0: Tree root (won't ever be rendered) 1:top level items 2..*: nestled child items
    readingUrl: string // "" means the tree node won't cause any articles to be displayed when clicked
    nobbGroup: string // An identifier which tells what nobb group should be associated with this tree item
    width: string
    height: string
    app: App // A reference back to the TreeView for validations etc.
    tree: TreeViewGW
    itemID: number
    childStatus: number // 0: has no parrent, 1: is child, 2: is last child
    lastBorn:boolean // True if there are no more L2 children under this L1 parent
    stage: number // 0: hidden under a collapsed parrent, 1: displayed, has no children , 2:displayed, has children
}

interface TreeItemStates {
    mouseState: string
}

export class TreeItemGW extends React.Component<TreeItemVm, TreeItemStates> {

    state: TreeItemStates = {
        mouseState: "out"
    }

    /* toggleExpanded toggles the expanded state on or off for a given tree item,
     * which always means on if the item was not the selected one for that hierarchy level.
     * The item does not need to be expandable (having children to display) to be set
     * as the expanded item - the expanded state also works as a selection of the item. */
    toggleExpanded() {
        // Toggles expanded at level 1
        if (this.props.level == 1) {

            if (this.props.tree.state.expandedItemL1 == this.props.itemID) {
                this.props.tree.setState({ expandedItemL1: this.props.itemID, showingAtLevel:1 })
            }
            else {
                this.props.tree.setState({ expandedItemL1: this.props.itemID, showingAtLevel:1 })
            }
        }

        // Toggles expanded at level 2
        if (this.props.level == 2) {
            if (this.props.tree.state.expandedItemL2 == this.props.itemID) {
                this.props.tree.setState({ expandedItemL2: this.props.itemID, showingAtLevel: 2 })
            }
            else {
                this.props.tree.setState({ expandedItemL2: this.props.itemID, showingAtLevel: 2 })
            }
        }

        // Toggles expanded at level 3
        if (this.props.level == 3) {
            if (this.props.tree.state.expandedItemL3 == this.props.itemID) {
                this.props.tree.setState({ expandedItemL3: this.props.itemID, showingAtLevel: 3 })
            }
            else {
                this.props.tree.setState({ expandedItemL3: this.props.itemID, showingAtLevel: 3 })
            }
        }

        // Toggles expanded at level 4
        if (this.props.level == 4) {
            if (this.props.tree.state.expandedItemL4 == this.props.itemID) {
                this.props.tree.setState({ expandedItemL4: -1 })
            }
            else {
                this.props.tree.setState({ expandedItemL4: this.props.itemID })
            }
        }

        // Toggles expanded at level 5
        if (this.props.level == 5) {
            if (this.props.tree.state.expandedItemL5 == this.props.itemID) {
                this.props.tree.setState({ expandedItemL5: -1 })
            }
            else {
                this.props.tree.setState({ expandedItemL5: this.props.itemID })
            }
        }
    }

    onMouseOver() {
        this.setState({ mouseState: "hover" })
    }

    onMouseDown() {
        this.setState({ mouseState: "pressed" })
    }

    onClick() {
        var openContent = false

        // On level 1 the contents will be shown
        if (this.props.level == 1) {
            openContent = true
        }

        // On level 2 the contents will be shown
        if (this.props.level == 2) {
            openContent = true
        }

        // On level 3 the contents will be shown
        if (this.props.level == 3) {
            openContent = true
        }

        if (openContent) {
            // opens a list of articles in the article view
            if (this.props.readingUrl != "") {
                this.props.app.setArticlesPageUrl(this.props.readingUrl)
            }
            else {
                PADebug.Log("TreeItemGW.onClick - opening nobb group:" + this.props.nobbGroup)
                this.props.app.setArticlesPageNobb(this.props.nobbGroup)
            }
        }
        
        this.toggleExpanded() // this will expand the item
    }

    onMouseUp() {
        this.setState({ mouseState: "hover" })
    }

    onMouseOut() {
        this.setState({ mouseState: "out" })
    }
 
    render() {
        // Stage 0 means this item is hidden (under a collapsed parrent item) and won't be rendered
        if (this.props.stage == 0) {
            return <div></div>
        }

        // default values (this should allways be overwritten and are left in red text to be noticed otherwise)
        var hoverStyle = {
            cursor: 'pointer', color: 'red', padding: '0px', borderBottom: '2px solid #C0C0C0',
            borderTop: '2px solid #F8F8F8', borderRight: '2px solid #E0E0E0', marginTop: '0px',
            borderLeft: '2px solid #E0E0E0', backgroundColor: '#f0f0f0', fontSize: '12px'
        }

        /* The background color of plus/minus signs and is-child-icons must of course harmonize with the
         * background color of the tree item, to do this, a value (iconOffset) will be set along with the
         * hoverstyle, which is later used as an image offset to display a version of the icon with the
         * correct background color. */

        var iconOffset = 0 // default value

        var contentMark = "" /* default is an empty string, but if within the selected articles there are atleast
                              * one within this tree item's cathegory, the contentMark will instead be "* ", to show
                              * there's something selected to be found under this tree item, this will be displayed
                              * prior to the group code on the tree item text. */

        // Primary level expansion/selection showed
        if (this.props.level == 1) {
            // Checking for selected contents that matches this item's group ID
            if (this.props.app.GetCore().CheckForSelectionContents(this.props.nobbGroup, 1) == true) {
                contentMark = "* "
            }

            // item style when the mouse is pressed
            if (this.state.mouseState == "pressed") {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '1px', borderBottom: '1px solid #C0C0C0',
                    borderTop: '1px solid #d8d8d8', borderRight: '2px solid #E0E0E0', marginTop: '0px',
                    borderLeft: '2px solid #E0E0E0', backgroundColor: '#e8e8e8', fontSize: '12px'
                }

                iconOffset = 1
            }

            // item style when the mouse is out
            if (this.state.mouseState == "out") {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '2px solid #E0E0E0',
                    borderTop: '2px solid white', borderRight: '2px solid #F0F0F0', marginTop: '0px',
                    borderLeft: '2px solid #F0F0F0', backgroundColor: '#fbfbfb', fontSize: '12px'
                }

                iconOffset = 2
            }
            
            // item style when the mouse is hovering
            if (this.state.mouseState == "hover") {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '2px solid #C0C0C0',
                    borderTop: '2px solid #F0F0F0', borderRight: '2px solid #E0E0E0', marginTop: '0px',
                    borderLeft: '2px solid #E0E0E0', backgroundColor: '#e0e0e0', fontSize: '12px'
                }

                iconOffset = 3
            }

            if (this.props.itemID == this.props.tree.state.expandedItemL1) {
                hoverStyle = {
                    cursor: 'pointer', color: 'white', padding: '2px', borderBottom: '0px solid #444142',
                    borderTop: '0px solid #747172', borderRight: '0px solid #545152', marginTop: '0px',
                    borderLeft: '8px solid #6491B2', backgroundColor: '#465A73', fontSize: '12px'
                }

                iconOffset = 4
            }
        }

        // Secondary level expansion/selection showed
        if (this.props.level == 2) {
            // Checking for selected contents that matches this item's group ID
            if (this.props.app.GetCore().CheckForSelectionContents(this.props.nobbGroup, 2) == true) {
                contentMark = "* "
            }

            // item style when the mouse is pressed
            if (this.state.mouseState == "pressed") {

                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px',
                    borderTop: '0px', borderRight: '0px', marginTop: '0px',
                    borderLeft: '2px solid #D0E0Ea', backgroundColor: '#b0c0d0', fontSize: '12px'
                }

                iconOffset = 6
            }

            // item style when the mouse is out
            if (this.state.mouseState == "out") {

                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px',
                    borderTop: '0px', borderRight: '0px', marginTop: '0px',
                    borderLeft: '2px solid #E0f0fa', backgroundColor: '#c0d0e0', fontSize: '12px'
                }

                iconOffset = 5
            }
            
            // item style when the mouse is hovering
            if (this.state.mouseState == "hover") {

                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px',
                    borderTop: '0px', borderRight: '0px', marginTop: '0px',
                    borderLeft: '2px solid #D0E0Ea', backgroundColor: '#b0c0d0', fontSize: '12px'
                }

                iconOffset = 6
            }

        }

        // Third level expansion/selection showed
        if (this.props.level == 3) {
            // Checking for selected contents that matches this item's group ID
            if (this.props.app.GetCore().CheckForSelectionContents(this.props.nobbGroup, 3) == true) {
                contentMark = "* "
            }

            // item style when the mouse is out
            if (this.state.mouseState == "out") {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px solid #B0C0Ca',
                    borderTop: '0px solid #E8F8FF', borderRight: '2px solid #D0E0Ea', marginTop: '0px',
                    borderLeft: '2px solid #E0f0fa', backgroundColor: '#E0f0fa', fontSize: '12px'
                }

                iconOffset = 7
            }

            // item style when the mouse is hovering
            if (this.state.mouseState == "hover") {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px solid #A0B0Ba',
                    borderTop: '0px solid #D8E8EF', borderRight: '2px solid #C0D0Da', marginTop: '0px',
                    borderLeft: '2px solid #D0E0Ea', backgroundColor: '#D0E0Ea', fontSize: '12px'
                }

                iconOffset = 8
            }
            
            // item style when the mouse is pressed
            if (this.state.mouseState == "pressed") {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px solid #A0B0Ba',
                    borderTop: '0px solid #D8E8EF', borderRight: '2px solid #C0D0Da', marginTop: '0px',
                    borderLeft: '2px solid #D0E0Ea', backgroundColor: '#D0E0Ea', fontSize: '12px'
                }

                iconOffset = 8
            }

            // Style when the item is the selected one at the third child level
            if (this.props.itemID == this.props.tree.state.expandedItemL3) {
                hoverStyle = {
                    cursor: 'pointer', color: 'black', padding: '0px', borderBottom: '0px solid #B0C0Ca',
                    borderTop: '0px solid #E8F8FF', borderRight: '2px solid #D0E0Ea', marginTop: '0px',
                    borderLeft: '2px solid #E0f0fa', backgroundColor: '#E0f0fa', fontSize: '12px'
                }

                iconOffset = 7
            }
        }
        
        /* The following generates a centercore to be placed within the boundaries
           of the item, and which may (or may not) include an icon to the right and
           to the left. To the left there may be a sign showing that this
           item is child to another item, and if it has siblings following after or not.
           to the right there may be a plus or minus sign in case this item has child
           items. In the center of the core the Item text will be shown.               */

        /* Default empty centercore - (This will allways be replaced but it guarantees
           to the compiler that there is a value set for centercore. )  */
        var centerCore = <div></div>

        // Forming up the centercore, here is another default value that will also be replaced.
        var innerSection = <div></div>

        var whiteText = ((this.props.level == 1) && (this.props.tree.state.expandedItemL1 == this.props.itemID)) ? true : false
        var selectionMark = ((this.props.level == 3) && (this.props.tree.state.showingAtLevel == 3) && (this.props.tree.state.expandedItemL3 == this.props.itemID)) ? true : false

        if (selectionMark == false) {
            selectionMark = ((this.props.level == 2) && (this.props.tree.state.showingAtLevel == 2) && (this.props.tree.state.expandedItemL2 == this.props.itemID)) ? true : false
        }

        if (selectionMark == false) {
            selectionMark = ((this.props.level == 1) && (this.props.tree.state.showingAtLevel == 1) && (this.props.tree.state.expandedItemL1 == this.props.itemID)) ? true : false
        }
        
        if (this.props.stage == 1) {
            // Stage 1 means the item has no child items, so no plus or minus sign will be added.

            if (selectionMark == true) {
                var bgPosX = -1 - (iconOffset * 32)
                var bgPosY = -1 - (30 * 2)
                var bgPos = bgPosX + "px " + bgPosY + "px"
                innerSection = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                    <div style={{ height: "100%", padding: "5px", color: (whiteText) ? "white" : "black" }}>
                        {contentMark + this.props.itemText}
                    </div>
                    <div style={{
                        height: "25px",
                        width: "30px",
                        cursor: "pointer",
                        backgroundImage: "url(images/TreeviewIcons.png)",
                        backgroundPosition: bgPos,
                        position: "relative",
                        top:"1px"
                    }}>
                    </div>
                </div>
            }
            else {
                innerSection = <div style={{ height: "100%", width: "100%", padding: "5px", color: (whiteText) ? "white" : "black" }}>
                    {contentMark + this.props.itemText}
                </div>
            }
        }
        else {
            // This item is a parent, now let's find out if it is expanded or not (plus or minus sign)
            var expanded = false

            // Checking at level 1
            if ((this.props.level == 1) && (this.props.tree.state.expandedItemL1 == this.props.itemID)) {
                expanded = true
            }

            // Checking at level 2
            if ((this.props.level == 2) && (this.props.tree.state.expandedItemL2 == this.props.itemID)) {
                expanded = true
            }
            
            // Checking at level 3
            if ((this.props.level == 3) && (this.props.tree.state.expandedItemL3 == this.props.itemID)) {
                expanded = true
            }

            // Checking at level 4
            if ((this.props.level == 4) && (this.props.tree.state.expandedItemL4 == this.props.itemID)) {
                expanded = true
            }

            // Checking at level 5
            if ((this.props.level == 5) && (this.props.tree.state.expandedItemL5 == this.props.itemID)) {
                expanded = true
            }

            // This item is a parent.
            if (expanded == true) {
                // The item has children to be rendered (minus symbol shown)

                if (selectionMark == true) {
                    var bgPosX = -1 - (iconOffset * 32)
                    var bgPosY = -1 - (30 * 2)
                    var bgPos = bgPosX + "px " + bgPosY + "px"
                    innerSection = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{ height: "100%", padding: "5px", color: (whiteText) ? "white" : "black" }}>
                            {contentMark + this.props.itemText}
                        </div>
                        <div style={{
                            height: "26px",
                            width: "30px",
                            cursor: "pointer",
                            backgroundImage: "url(images/TreeviewIcons.png)",
                            backgroundPosition: bgPos,
                            position: "relative",
                            top: "1px"
                        }}>
                        </div>
                    </div>
                }
                else {
                    var bgPosX = -1 - (iconOffset * 32)
                    var bgPosY = -1 - (30 * 1)
                    var bgPos = bgPosX + "px " + bgPosY + "px"
                    innerSection = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{ height: "100%", width: "calc(100% - 36px)", padding: "5px", color: (whiteText) ? "white" : "black" }}>
                            {contentMark + this.props.itemText}
                        </div>
                        <div style={{ height: "100%", width: "36px" }}>
                        </div>
                    </div>
                }
            }
            else {
                // The item has hidden children (plus symbol shown)
                var bgPosX = -1 - (iconOffset * 32)
                var bgPosY = -1 - (30 * 0)
                var bgPos = bgPosX + "px " + bgPosY + "px"
                innerSection = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                    <div style={{ height: "100%", width: "calc(100% - 36px)", padding: "5px", color: (whiteText) ? "white" : "black"  }}>
                        {contentMark + this.props.itemText}
                    </div>
                    <div style={{
                        height: "26px",
                        width: "30px",
                        cursor: "pointer",
                        backgroundImage: "url(images/TreeviewIcons.png)",
                        backgroundPosition: bgPos
                    }}>
                    </div>
                    <div style={{ height: "100%", width: "6px" }}>
                    </div>
                </div>
            }
        }

        // childStatus 0 means the item is not displayed as a child to any other item
        if (this.props.childStatus == 0) {
            // There are no parent or child items above or under this item.
            centerCore = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%", color: (whiteText) ? "white" : "black" }}>
                {innerSection}
            </div>
        }
        else {
            var topBorderColor = "2px solid #E0f0fa"
            if (this.state.mouseState == "hover") {
                topBorderColor = "2px solid #D0E0Ea"
            }

            // the item is a child to another item (has child status 1 or 2)
            if (this.props.childStatus == 1) {
                // this child item has siblings following it
                
                if (this.props.level == 3) {
                    var bgPosX = -1 - (iconOffset * 32)
                    var bgPosY = -1 - ((this.props.lastBorn == true) ? ((30 * 3) + 72) : (30 * 3))
                    var bgPos = bgPosX + "px " + bgPosY + "px"

                    centerCore = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{
                            height: "27px",
                            width: "30px",
                            cursor: "pointer",
                            backgroundImage: "url(images/TreeviewIcons.png)",
                            backgroundPosition: bgPos
                        }}>
                        </div>
                        {innerSection}
                    </div>
                }
                else {
                    var bgPosX = -1 - (iconOffset * 32)
                    var bgPosY = -1 - ((this.props.lastBorn == true) ? (30 * 4) : (30 * 3))
                    var bgPos = bgPosX + "px " + bgPosY + "px"

                    centerCore = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{
                            height: "29px",
                            width: "20px",
                            cursor: "pointer",
                            backgroundImage: "url(images/TreeviewIcons.png)",
                            backgroundPosition: bgPos
                        }}>
                        </div>
                        <div style={{ borderTop: topBorderColor, width: "calc(100% - 20px)" }}>
                            {innerSection}
                        </div>
                    </div>
                }
            }
            else {
                // this child item has no siblings following it
                
                if (this.props.level == 3) {
                    var bgPosX = -1 - (iconOffset * 32)
                    var bgPosY = -1 - ((this.props.lastBorn == true) ? ((30 * 4)+72) : (30 * 4))
                    var bgPos = bgPosX + "px " + bgPosY + "px"
                    centerCore = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{
                            height: "27px",
                            width: "30px",
                            cursor: "pointer",
                            backgroundImage: "url(images/TreeviewIcons.png)",
                            backgroundPosition: bgPos
                        }}>
                        </div>
                        {innerSection}
                    </div>
                }
                else {
                    var bgPosX = -1 - (iconOffset * 32)
                    var bgPosY = -1 - ((this.props.lastBorn == true) ? (30 * 4) : (30 * 3))
                    var bgPos = bgPosX + "px " + bgPosY + "px"
                    centerCore = <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%" }}>
                        <div style={{
                            height: "29px",
                            width: "20px",
                            cursor: "pointer",
                            backgroundImage: "url(images/TreeviewIcons.png)",
                            backgroundPosition: bgPos
                        }}>
                        </div >
                        <div style={{ borderTop: topBorderColor, width: "calc(100% - 20px)"}}>
                            {innerSection}
                        </div>
                    </div>
                }
            }
        }

        // Puting all togeather and returning the result
        return <div
            onMouseOut={this.onMouseOut.bind(this)}
            onMouseOver={this.onMouseOver.bind(this)}
            onMouseDown={this.onMouseDown.bind(this)}
            onMouseUp={this.onMouseUp.bind(this)}
            onClick={this.onClick.bind(this)}
            style={hoverStyle}>{centerCore}</div>;
    }
}


// WEBPACK FOOTER //
// ./client/view/TreeItemGW.tsx